import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
  DoCheck, ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogAlertComponent } from '../../shared/components/dialog-alert/dialog-alert.component';

// Constants
import { masks } from '../../shared/constants/masks';
import { SYDLEClientID } from '../../shared/constants/one-constants';
import { states } from '../../shared/constants/states';
import { errorMapping } from '../../shared/constants/errors';
import { hideChangePlanProducts } from "../../shared/constants/single-plan-products";

// Enums
import { Dtm, getDtm, Mapping } from '../../shared/enum/dtm';

// Models
import { Customer } from '../../shared/model/customer';

// Services
import { CartService } from 'src/app/shared/services/cart.service';
import { CustomerService } from 'src/app/shared/services/customer.service';
import { FormControlService } from 'src/app/services/form-control.service';
import { LocationService } from 'src/app/shared/services/location.service';
import { SessionStorageService } from 'src/app/shared/services/session-storage.service';
import { ECommerceService } from "../../services/e-commerce.service";

import { DtmService } from 'src/app/services/dtm.service';

import { DialogLoadingComponent } from '../../shared/components/dialog-loading/dialog-loading.component';
import { LoadingComponent } from 'src/app/shared/components/loading/loading.component';
import { CheckoutService } from '../../shared/services/checkout.service';
import { CheckoutSuccessData } from '../../shared/model/checkout-success-data';
import { environment } from '../../../environments/environment';
import { CartComponent } from '../../shared/components/cart/cart.component';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { DialogData } from 'src/app/shared/model/dialog-data';
import { CookieService } from 'ngx-cookie-service';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'pme-checkout-identification',
    templateUrl: './identification.component.html',
    styleUrls: ['./identification.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CheckoutIdentificationComponent implements OnInit, AfterViewInit, DoCheck {

  // Buttons and Bottom Sheet Cart Component Variables
  @Input() buttonRouterLink: string;
  @Input() buttonName: string;

  customer: Customer = this.customerService.getCurrentCustomer() || new Customer();
  private cartUpdatedSubscription: Subscription = null;

  @ViewChild(CartComponent) cartComponent: CartComponent;
  cartLoaded: boolean;

  // Form Variables
  birthDate: string;
  cellphone: string;
  cnpj: string;
  companyLegalName: string;
  companyName: string;
  cpf: string;
  email: string;
  hasValidZipcode: boolean;
  lastEnteredZipcode = '';
  masks = masks;
  hideFields: any = {};
  selectedIndex = 0;
  hideRegister = false;
  submitButtonName = "Continuar";

  // Form Variables
  hasDigitalCommerceAddressData = false;
  hasUserDataErrors = false;
  hasBusinessDataErrors = false;
  hasDigitalCommerceLegalName = false;

  name: string;
  onSubmitIdentificationErrors: Array<string> = [];
  states: Array<string> = states;
  submitted = false;
  submitting: boolean;

  // Provisioning Parameters Variables
  userId: string;
  businessId: string;
  logon: string;
  platformAccess: string;
  distributor: string;

  // route parameters Variables
  product: string;
  couponUrl: string;

  // Parametros do produto Lista Online
  quantidade: number;
  externalSignatureId: string;
  checksum: string;
  internalReference: string;
  ref: string;
  invalidChecksum: boolean;

  //Televendas variables
  validationToken: string;

  // Step Variables
  step = 'identificacao';
  classificationIdentifier: string;
  classificationName: string;

  mitigated: boolean;
  userData: boolean;
  isLogged: boolean;
  zipcodeData: boolean;
  coupon: string;
  redirectUrl: any = environment.serasaHomePage;
  showBackButton = false;
  changeProductLink: string;
  changeProductText: string;
  cardTitle: string;
  userValidated = false;
  userRegistered = false;
  userPromoted = false;
  hideIdentification: boolean = true;
  spinnerDialogRef: MatDialogRef<LoadingComponent>;
  firstSubmit = true;

  constructor(
    private cookieService: CookieService,
    private customerService: CustomerService,
    private locationService: LocationService,
    private route: ActivatedRoute,
    private router: Router,
    private sessionStorageService: SessionStorageService,
    public cartService: CartService,
    public formControlService: FormControlService,
    public checkoutService: CheckoutService,
    public dialog: MatDialog,
    public dtmService: DtmService,
    private eCommerceService: ECommerceService,
    private utils: UtilsService
  ) {

    //Limpa a sessionStorage no início do fluxo
    //sessionStorage.clear();
    this.sessionStorageService.clearSessionStorage(
      ['customer', 'identificationCompleted', 'name', 'email', 'redirectURL', 'selfAttendanceData']);

    this.customer = new Customer();

    // Valida se o usuario esta comecando o fluxo pela identificacao
    this.fillProvisioningData();

    // Gets the category from URL or SessionStorage
    this.classificationIdentifier = this.sessionStorageService.checkAndSetClassification(this.route);
    this.classificationName = this.sessionStorageService.getClassificationName();

    // Gets the UserID and BusinessId from SessionStorage
    this.getProvisioningParametersFromSessionStorage();

    //Verifica se há um plano mensal ativo para que a recarga pontual esteja disponível
    if (this.classificationIdentifier === "plano-mensal-recarga-pontual") {
      this.checkRechargeAvailability();
    }

    this.route.queryParams.subscribe((params) => {
      console.log('Query Params:', "rennan", params);
      if (params.userId && params.businessId) {
        this.userId = params.userId;
        this.businessId = params.businessId;
        this.logon = params.logon;
        this.distributor = params.distributor ? params.distributor : null;
        this.platformAccess = params.platformAccess;
        this.setProvisioningParametersOnSessionStorage();
      }

      this.sessionStorageService.setAdditionalData({
        byParameter: {
          customValue: null
        }
      });

      if (params.customValue) {
        this.sessionStorageService.setAdditionalData({
          byParameter: {
            customValue: params.customValue
          }
        });
      }

      if (params.isDelend) {
        sessionStorage.setItem('isDelend', params.isDelend);
        sessionStorage.setItem('purchaseOrigin', "isDelendSale");
      }

      this.sessionStorageService.setAdditionalData({byParameter: {
          isCampaign: null
        }});

      if (params.isCampaign) {
        this.sessionStorageService.setAdditionalData({byParameter: {
          isCampaign: params.isCampaign
        }});
      }

      if (params.platformAccess) {
        sessionStorage.setItem('platformAccess', params.platformAccess);
      }

      if (params.redirectUrl) {
        sessionStorage.setItem('successRedirectUrl', params.redirectUrl);
      }

      const ssProduct = this.sessionStorageService.getProduct();

      if (params.plan) {
        this.product = params.plan;

        // Em caso de alterar o produto do sessionStorage, apaga os cupons aplicados
        // e remove cupons aplicados
        if (ssProduct !== this.product) {
          this.deleteCouponFromCart();
          this.sessionStorageService.resetSessionStorage();
        }
      }

      if (params.package) {
        this.product = params.package;

        if (ssProduct !== this.product) {
          this.sessionStorageService.resetSessionStorage();
          this.deleteCouponFromCart();
        }
      }

      if (params.coupon) {
        this.sessionStorageService.removeCoupon();
        this.couponUrl = params.coupon;
        this.sessionStorageService.setCoupon(this.couponUrl);
      }

      // Parametros do produto Lista Online
      if (params.quantidade) {
        this.quantidade = params.quantidade;
      }

      if (params.externalSignatureId) {
        this.externalSignatureId = params.externalSignatureId;
      }

      if (params.cs) {
        this.checksum = params.cs;
      }

      if (params.internalReference) {
        this.internalReference = params.internalReference;
      }

      if (params.validationToken) {
        this.validationToken = params.validationToken;
        sessionStorage.setItem('validationToken', this.validationToken);
      } else {
        this.validationToken = sessionStorage.getItem('validationToken');
      }

      if (params.newCustomer) {
        sessionStorage.setItem('newCustomer', params.newCustomer);
      }
      this.sessionStorageService.setProduct(this.product);

      this.sessionStorageService.clearSessionStorage(['cart', 'isUpgrade']);

      if (!this.utils.validateQueryParams({ userId: this.userId, businessId: this.businessId, product: this.product })) {
        if (!this.product || this.product === "undefined" || this.product === "null")
          this.utils.returnToShopWindow();
        else
          this.utils.returnToLoginPage();

        return;
      }

      this.fillCartWithUrlParameters();

      // Verify if this business and user already has a purchase pending
      this.checkPendingPaymentPurchase();

      // Gets the userId and businessId integration and binds to customer
      this.bindProvisioningParameters();

      this.getTelevendasData();

      // Adobe Analytics
      this.dtmService.customLoaded(['Identificacao']);

      this.sessionStorageService.setAdobeMobileData(params.adobeMobileData);

      if (this.product) {
        this.dtmService.productsLoaded([
          {
            identifier: this.product,
            classificationName: this.classificationName ? this.classificationName : this.classificationIdentifier ? Mapping[this.classificationIdentifier] : null
          }
        ]);
      }
    });
    this.changeProductLink = sessionStorage.getItem('shopWindowRoute');

    if (this.changeProductLink === 'meu-plano') {
      this.cardTitle = 'Plano selecionado';
      this.changeProductText = 'Mudar plano';
    } else if (this.changeProductLink === 'meu-pacote') {
      this.changeProductText = 'Mudar pacote';
      this.cardTitle = 'Pacote selecionado';
    }

    // Remove o botao de "Mudar plano/pacote" caso o produto seja unitario
    if (hideChangePlanProducts.includes(this.classificationIdentifier)) {
      this.changeProductText = null;
      this.changeProductLink = null;
    }
  }

  checkRechargeAvailability() {
    this.customerService
      .getContractStatusByProvisioningParameters(this.businessId, this.userId, "plano-mensal")
      .subscribe(
        (result) => {
          if (result) {
            if (result.product.classification !== "plano-mensal" || (result.contractStatus !== "ACTIVE" && result.contractStatus !== "SUSPENDED")) {
              window.location.href = 'https://www.serasaempreendedor.com.br/';
            }
          } else {
            window.location.href = 'https://www.serasaempreendedor.com.br/';
          }
        }
      );
  }

  checkPendingPaymentPurchase() {
    if (this.userId && this.businessId) {
      this.customerService.checkIfAlreadyPurchased(this.businessId, this.userId, this.classificationIdentifier, this.product).subscribe(
        (checkoutData: CheckoutSuccessData) => {
          if (checkoutData && checkoutData.pendingPaymentPurchase === true) {
            this.checkoutService.setCheckoutSuccessData(checkoutData);
            this.closeDialogSpinner();
            this.router.navigateByUrl(`auto-atendimento/${this.classificationIdentifier}/processando`);
          }
        },
        (error) => {
          this.showCustomError('checkIfAlreadyPurchasedError', error);
        }
      );
    }
  }

  storeIdentificationIndex(identifier: number) {
    if (this.selectedIndex == 0 && this.customer.zipcode) {
      this.updateAddressFromZipcode(this.customer.zipcode);
    }
    this.selectedIndex = identifier;

    this.formControlService.changeIdentificationIndex(identifier);
  }

  ngOnInit() {
    this.dtmService.pageLoaded(Dtm.Identificacao, true, getDtm(Dtm.Identificacao, this.classificationIdentifier));
    const customer = this.sessionStorageService.getCustomer();
    // Atualiza os dados do cliente no sessionStorage e na
    if (customer) {
      this.customer = customer;
      this.sessionStorageService.setValidationDataFromCustomer(this.customer);
    }

    this.cartUpdatedSubscription = this.cartService.cartUpdated.subscribe(
      (event) => {
        const cart = this.cartService.getCurrentCart();
        if (cart) {
          this.dtmService.productsLoaded([
            {
              identifier: cart.product.identifier,
              classificationName: cart.product.classificationName
            }
          ]);
        }

        this.cartUpdatedSubscription.unsubscribe();
      }
    );
  }

  ngAfterViewInit(): void {
    this.formControlService.identificationForm.valueChanges.subscribe(
      (value: any) => {
        if (this.firstSubmit) return
        if (
          this.customer &&
          this.customer.zipcode !== this.lastEnteredZipcode
        ) {
          if (
            value.zipcode &&
            value.zipcode.replace(/[^0-9]/g, '').length === 8
          ) {
            if (value.zipcode !== this.lastEnteredZipcode) {
              this.lastEnteredZipcode = value.zipcode;
              this.updateAddressFromZipcode(value.zipcode);
            }
          } else {
            this.clearAddress();
          }
        }

        this.updateCurrentCustomer();
      }
    );

    if (!this.validationToken) {

      let isVendaDeslogada: any;
      isVendaDeslogada = sessionStorage.getItem("vendaDeslogada");
      this.isLogged = this.sessionStorageService.getIsLogged();
      if (!isVendaDeslogada) {
        isVendaDeslogada = this.isLogged
      } else {
        isVendaDeslogada = isVendaDeslogada && isVendaDeslogada !== "true";
      }
      this.dtmService.pageLoaded(Dtm.Identificacao, isVendaDeslogada, getDtm(Dtm.Identificacao, this.classificationIdentifier));
      // this.dtmService.sendPageLoadEvent();

    }
  }

  ngDoCheck(): void {
    const shoppingCart = sessionStorage.getItem('cart');

    if (shoppingCart !== null) {
      this.cartService.getSessionStorageCart();
    }
  }

  // Preenche as informacoes de plano, userId e businessId
  // da URL, se forem informadas, ou pega os dados do sessionStorage.
  // Caso exista um checkoutSuccessData de outra compra no localStorage, apaga-o
  // Caso o userId ou businessId informado na URL seja diferente do salvo no SS, apaga o SS
  fillProvisioningData() {
    let resetSessionStorage = false;

    if (JSON.parse(localStorage.getItem('checkoutSuccessData'))) {
      this.sessionStorageService.resetSessionStorage();
      localStorage.removeItem('checkoutSuccessData');
    }

    const userId = this.sessionStorageService.getUserId();
    const businessId = this.sessionStorageService.getBusinessId();
    if (userId || businessId) {
      this.userId = this.sessionStorageService.getUserId();
      this.businessId = this.sessionStorageService.getBusinessId();
    }

    this.product = this.sessionStorageService.getProduct();

    // Busca os parametros na URL
    this.route.queryParams.subscribe(params => {
      if (params.plan) {
        this.product = params.plan;
      }

      if (params.package) {
        this.product = params.package;
      }

      if (params.coupon) {
        this.couponUrl = params.coupon;
      }

      if (params.userId) {
        resetSessionStorage = (params.userId !== this.userId);
        this.userId = params.userId;
      }

      if (params.businessId) {
        resetSessionStorage = (params.businessId !== this.businessId);
        this.businessId = params.businessId;
      }

      if (params.logon) {
        resetSessionStorage = (params.logon !== this.logon);
        this.logon = params.logon;
      }

      if (params.distributor) {
        resetSessionStorage = (params.distributor !== this.distributor);
        this.distributor = params.distributor;
      }

      if (params.platformAccess) {
        resetSessionStorage = (params.platformAccess !== this.platformAccess);
        this.platformAccess = params.platformAccess;
      }

      // Obtem user e business id do parametro ref em base64
      if (params.ref) {
        this.ref = atob(params.ref);
        const [refUserId, refBusinessId] = this.ref.split(':');

        if (refUserId) {
          resetSessionStorage = (refUserId !== this.userId);
          this.userId = refUserId;
        }
        if (refBusinessId) {
          resetSessionStorage = (refBusinessId !== this.businessId);
          this.businessId = refBusinessId;
        }
      }
    });

    if (this.userId !== undefined && this.businessId !== undefined) {
      // this.sessionStorageService.setIsLogged(true);
    } else {
      this.sessionStorageService.setIsLogged(false);
      this.submitButtonName = "Acessar no site";
      this.hideRegister = true;
      ////Esconder o campo razão social na venda deslogada
      this.disableAndHideField('legalName');
    }

    if (resetSessionStorage) {
      this.sessionStorageService.resetSessionStorage(true);
      this.sessionStorageService.setUserIdAndBusinessId(this.userId, this.businessId, this.logon, this.distributor);
      this.sessionStorageService.setProduct(this.product);
    }
  }

  checkAndSubmit() {
    if (
      this.userId &&
      this.businessId &&
      (this.formControlService.identificationForm.valid || this.firstSubmit)
    ) {
      // this.dtmService.customClickEvent(
      //   'checkAndSubmitAutomatico',
      //   'identificacao'
      // );
      this.onSubmit();
      this.closeDialogSpinner();
    } else if (this.checkForUserInput()) {
      if (this.firstSubmit) this.clearAddress(true);
      this.closeDialogSpinner();
    }
  }

  checkForUserInput() {
    // Se não tiver businessId e nem UserId não pode continuar.
    if (!this.userId || !this.businessId) {
      return false;
    }

    // Caso tenha tido algum erro de dados obrigatórios não pode continuar
    if (this.hasUserDataErrors || this.hasBusinessDataErrors) {
      return false;
    }

    if (this.hasDigitalCommerceAddressData === false ||
      this.zipcodeData === false ||
      this.hasDigitalCommerceLegalName === false) {
      return true;
    }

    return true;
  }

  // TODO - Passar a venda logada para 1 script só no backend
  onSubmit() {
    this.openDialogSpinner();
    const sessionCoupon = sessionStorage.getItem('coupon') || "";
    if (this.formControlService.identificationForm.valid || this.firstSubmit) {
      if (this.selectedIndex == 1) {

        this.eCommerceService.getSpecificURL("identification_login", {
          email: btoa(this.customer.email),
          classificationIdentifier: this.classificationIdentifier,
          product: this.product,
          coupon: sessionCoupon
        })
          .subscribe((result) => {
            if (result.route) {
              this.closeDialogSpinner();
              document.location.href = result.route;
            }
          })

      } else {

        this.onSubmitIdentificationErrors = [];
        this.submitting = true;

        // Se a venda nao é logada
        if (!this.sessionStorageService.getIsLogged()) {

          //Se o usuário ainda não foi promovido
          if (!this.userPromoted) {

            const classification = this.sessionStorageService.getClassification();
            this.customerService.getMitigationData(this.customer.cnpj, classification).subscribe(mitigationData => {

              //Usuário mitigado
              if (mitigationData && mitigationData.mitigated === true) {
                let errorDetail = "CODE:" + mitigationData.status + ":HTTP:" + mitigationData.status + ":POST/" + mitigationData.url + ":MITIGATION_MESSAGE_ERROR_PRE_CADASTRO";
                this.showCustomError('mitigationMessageErrorPreCadastro', errorDetail);
              } else if (mitigationData.mitigated === false) {

                this.customerService.validateIdentity(this.customer, classification).subscribe(validationResult => {
                  if (validationResult && validationResult.validationCode) {
                    this.userValidated = true;
                    this.customer.provisioningParameter.validationCode = validationResult.validationCode;
                    this.customerService.registerUser(this.customer, classification, this.product, sessionCoupon).subscribe(registrationResult => {
                      // Sucesso na chamada do RegisterUser
                      if (registrationResult && registrationResult.userId && registrationResult.businessId) {
                        this.userRegistered = true;
                        this.businessId = registrationResult.businessId;
                        this.userId = registrationResult.userId;
                        this.customer.provisioningParameter.businessId = this.businessId;
                        this.customer.provisioningParameter.userId = this.userId;

                        // Analytics - Sucesso no cadastro do cliente
                        this.dtmService.customLoaded(['CadastroInicio'], null, { businessId: this.businessId, clientId: SYDLEClientID, userId: this.userId, logon: this.logon });
                        this.dtmService.sendPageLoadEvent('CadastroInicio');

                        this.customerService.promoteUser(this.businessId, this.userId, validationResult.validationCode, classification).subscribe(promoteResult => {
                          if (promoteResult && promoteResult.success) {
                            this.userPromoted = true;

                            // Analytics - Sucesso no promote do cliente
                            this.dtmService.customLoaded(['IdValidation'], null, { businessId: this.businessId, clientId: SYDLEClientID, userId: this.userId, logon: this.logon }, { role: 'userAuthenticatedSydle', origem: 'Sydle' });
                            this.dtmService.sendPageLoadEvent('SucessoIDValidation');

                            this.customerService.getBusinessAccountData(this.businessId, classification, true).subscribe((result) => {
                              const businessData = result.businessData;

                              //Usuário mitigado
                              if (businessData.mitigated === true) {

                                this.userPromoted = false;
                                let errorDetail = "CODE:" + (result.code || result.status) + ":HTTP:" + result.status + ":POST//customer-relationship/lead/v1/screenings/business-accounts/{{businessId}}:MITIGATION_MESSAGE_ERROR_POS_CADASTRO";
                                this.showCustomError('mitigationMessageErrorPosCadastro', errorDetail);

                              } else if (businessData.mitigated === false) {

                                if (businessData.company) {

                                  if (businessData.company.aliasName) {
                                    this.customer.companyName = businessData.company.aliasName
                                    this.hasDigitalCommerceLegalName = true;
                                  }
                                  if (businessData.company.socialName) {
                                    this.customer.companyLegalName = businessData.company.socialName;
                                    this.hasDigitalCommerceLegalName = true;
                                  }
                                  if (businessData.company.legalName) {
                                    this.customer.companyLegalName = businessData.company.legalName;
                                    this.hasDigitalCommerceLegalName = true;
                                  }

                                  //Se empresa tem nome - a venda segue normalmente
                                  if (this.hasDigitalCommerceLegalName || this.customer.companyLegalName) {

                                    this.disableAndHideField('legalName');
                                    this.updateCurrentCustomer();
                                    this.setProvisioningParametersOnSessionStorage();
                                    sessionStorage.setItem('identificationCompleted', 'true');
                                    sessionStorage.setItem('notLoggedSale', 'true');
                                    sessionStorage.setItem('vendaDeslogada', 'true');
                                    sessionStorage.setItem('successRedirectUrl', 'https://www.serasaempreendedor.com.br/cadastro/resgatar-senha');

                                    this.closeDialogSpinner();
                                    this.navigateToNextStep();

                                    //Se a empresa não tem nome, torna o campo razão social obrigatório e bloqueia os demais para edição
                                  } else {
                                    this.onSubmitIdentificationErrors.push(errorMapping['noCompanyNameFound']);

                                    this.dtmService.customErrorLoaded(['error'], {
                                      errorDetail: JSON.stringify(result),
                                      errorMessage: 'Não foi possível obter a razão social da empresa. Por favor informe a razão social.',
                                    });

                                    this.enableAndShowField('legalName');
                                    this.submitting = false;
                                    this.closeDialogSpinner();

                                    this.setFieldAsReadOnly('cnpj');
                                    this.setFieldAsReadOnly('cpf');
                                    this.setFieldAsReadOnly('name');
                                    this.setFieldAsReadOnly('birthDate');
                                    this.setFieldAsReadOnly('cellphone');
                                    this.setFieldAsReadOnly('email');
                                  }

                                } else {
                                  this.submitting = false;
                                  this.closeDialogSpinner();
                                  this.openErrorDialog("DEFAULT_ERROR");
                                }

                              }
                            }, err => {
                              this.submitting = false;
                              this.closeDialogSpinner();
                              let errorDetail = "CODE:" + (err.code || err.status) + ":HTTP:" + err.status + ":POST//customer-relationship/lead/v1/screenings/business-accounts/{{businessId}}:INTEGRATION_ERROR";
                              this.openErrorDialog("DEFAULT_ERROR", errorDetail);
                            });
                          } else {
                            this.submitting = false;
                            this.closeDialogSpinner();
                            let errorDetail = "CODE:" + (promoteResult.code || promoteResult.status) + ":HTTP:" + promoteResult.status + ":POST//" + promoteResult.url;
                            this.openErrorDialog(promoteResult.errorData, errorDetail, 'Resultado do promote falso');
                          }
                        }, err => {
                          this.submitting = false;
                          this.closeDialogSpinner();
                          let errorDetail = "CODE:" + (err.code || err.status) + ":HTTP:" + err.status + ":POST//cross-domain/account/v1/business-accounts/promote-by-code:FALHA_AO_PROMOVER_USUARIO";
                          this.openErrorDialog('IDENTITY_ERROR', errorDetail, 'Falha ao promover usuário');
                        });
                      } else {
                        this.submitting = false;
                        this.closeDialogSpinner();
                        let errorDetail = "CODE:" + (registrationResult.code || registrationResult.status) + ":HTTP:" + registrationResult.status + ":POST//" + registrationResult.url;
                        this.openErrorDialog(registrationResult.errorData, errorDetail);
                      }
                    }, err => {
                      this.submitting = false;
                      this.closeDialogSpinner();
                      let errorDetail = "CODE:" + (err.code || err.status) + ":HTTP:" + err.status + ":POST//cross-domain/account/v1/business-accounts/register-partner:INTEGRATION_ERROR";
                      this.openErrorDialog("DEFAULT_ERROR", errorDetail, 'Falha ao cadastrar usuário');
                    });
                  } else {
                    //Usuário não é sócio, ocultar os campos da tela de identificação e exibir a mensagem de erro no lugar
                    let errorDetail = "CODE:" + (validationResult.code || validationResult.status) + ":HTTP:" + validationResult.status + ":POST//" + validationResult.url;
                    if (validationResult.errorData && validationResult.errorData.code && validationResult.errorData.code == '1') {
                      this.showCustomError('userNotAssociateError', errorDetail + ":USER_NOT_ASSOCIATE_ERROR");
                    } else if (validationResult.errorData && validationResult.errorData.code && validationResult.errorData.code == '2') {
                      this.submitting = false;
                      this.closeDialogSpinner();
                      let errorMsg = validationResult.errorData.title + validationResult.errorData.contents.join(";");
                      this.openErrorDialog(validationResult.errorData, errorDetail + ":IDENTITY_ERROR", errorMsg);
                    } else {
                      this.submitting = false;
                      this.closeDialogSpinner();
                      this.openErrorDialog(validationResult.errorData, errorDetail);
                    }
                  }
                }, err => {
                  this.submitting = false;
                  this.closeDialogSpinner();
                  let errorDetail = "CODE:" + (err.code || err.status) + ":HTTP:" + err.status + ":POST//digital/validation-domain/v1/validate-identity:VALIDATE_IDENTITY_INTEGRATION";
                  this.openErrorDialog("DEFAULT_ERROR", errorDetail);
                });
              } else {
                // Venda logada - Quando serviço de mitigação não retorna os dados se o usuário é mitigado ou não.
                this.showCustomError('requiredIntegrationDataNotFound');
              }
            }, err => {
              this.submitting = false;
              this.closeDialogSpinner();
              let errorDetail = "CODE:" + (err.code || err.status) + ":HTTP:" + err.status + ":POST//customer-relationship/lead/v1/screenings/current/countries/BRA/documents/{{cnpj}}/mitigations:MITIGATION_";
              this.openErrorDialog("DEFAULT_ERROR", errorDetail);
            });

            //Usuário já foi promovido
          } else if (this.userRegistered && this.userPromoted) {

            this.updateCurrentCustomer();
            this.setProvisioningParametersOnSessionStorage();
            sessionStorage.setItem('vendaDeslogada', 'true');
            sessionStorage.setItem('identificationCompleted', 'true');
            sessionStorage.setItem('notLoggedSale', 'true');
            sessionStorage.setItem('successRedirectUrl', 'https://www.serasaempreendedor.com.br/cadastro/resgatar-senha');
            this.closeDialogSpinner();
            this.navigateToNextStep();
          }
        } else {
          // Venda logada
          if (this.mitigated === false) {
            sessionStorage.setItem('identificationCompleted', 'true');
            this.updateCurrentCustomer();
            this.closeDialogSpinner();
            this.navigateToNextStep();
          } else if (this.mitigated === true) {
            // Venda logada - Usuário mitigado, não pode concluir a venda.
            this.showCustomError('mitigationMessageError');
          } else {
            // Venda logada - Quando serviço de mitigação não retorna os dados se o usuário é mitigado ou não.
            this.showCustomError('requiredIntegrationDataNotFound');
          }
        }
      }
    }
  }

  navigateToNextStep() {
    // Verifica se existe uma targetURL na sessionStorage
    // const targetUrl = sessionStorage.getItem('targetUrl');
    // if (targetUrl && targetUrl !== '') {
    //   this.router.navigate([targetUrl]);
    // } else {
    this.router.navigate(['../pagamento'], { relativeTo: this.route });
    // }

  }

  closeDialogSpinner(): void {
    this.hideValidFields();

    if (this.spinnerDialogRef) {
      this.spinnerDialogRef.close();
    }
    this.hideIdentification = false;
  }

  hideValidFields() {
    if (this.formControlService.identificationForm.valid === false) {
      this.hideFields.legalName = this.formControlService.identificationForm.controls.legalName.disabled;
      this.hideFields.cpf = this.formControlService.identificationForm.controls.cpf.disabled;
      this.hideFields.cnpj = this.formControlService.identificationForm.controls.cnpj.disabled;
      this.hideFields.name = this.formControlService.identificationForm.controls.name.disabled;
      this.hideFields.birthDate = this.formControlService.identificationForm.controls.birthDate.disabled;
      this.hideFields.email = this.formControlService.identificationForm.controls.email.disabled;
      this.hideFields.cellphone = this.formControlService.identificationForm.controls.cellphone.disabled;
    }
  }

  openDialogSpinner(): void {
    this.closeDialogSpinner();
    this.hideIdentification = this.firstSubmit;
    this.spinnerDialogRef = this.dialog.open(LoadingComponent, {
      disableClose: true,
      width: '400px',
      panelClass: 'pme-dialog-loading-panel',
      backdropClass: 'pme-dialog-loading-backdrop'
    });
  }

  updateCurrentCustomer(): void {
    this.customerService.setCurrentCustomer(this.customer);
  }

  checkRequiredAddressFields() {
    const requiredFields = ["street", "number", "quarter", "city", "state", "zipcode"];

    for (let field of requiredFields) {
      if (!this.customer[field]) return false;
    }
    return true;
  }

  updateAddressFromZipcode(zipcode: string): boolean {
    if (this.firstSubmit) return;
    this.openDialogSpinner();
    this.locationService.getAddressByZipcode(zipcode.replace(/[^0-9]/g, ''), false)
      .subscribe((addressResult: any) => {
        this.hasValidZipcode = true;
        this.formControlService.identificationForm.controls.zipcode.setErrors(null);

        const isAddressValid = this.checkRequiredAddressFields();
        if (!isAddressValid) this.fillAddressParameters(addressResult);
      },
        (err: any) => {
          console.log('err: ', err);
          this.closeDialogSpinner();
          this.handleRequestError('getAddressByZipcode', err, 'Informe um CEP válido');
          this.formControlService.identificationForm.controls.zipcode.setErrors(
            { invalidZipcode: 'Informe um CEP válido' }
          );
          return false;
        },
        () => {
          this.closeDialogSpinner();
        }
      );
    return true;
  }

  fillAddressParameters(address): void {
    if (address.street) {
      this.customer.street = address.street;
      this.formControlService.identificationForm.get('street').disable();
    }

    if (address.quarter) {
      this.customer.quarter = address.quarter;
      this.formControlService.identificationForm.get('quarter').disable();
    }

    if (address.city) {
      this.customer.city = address.city;
      this.formControlService.identificationForm.get('city').disable();
    }

    if (address.state) {
      this.customer.state = address.state;
      this.formControlService.identificationForm.get('state').disable();
    }

    this.zipcodeData = !(
      !address.quarter ||
      !address.street ||
      !address.state
    );

    this.updateCurrentCustomer();
  }

  setProvisioningParametersOnSessionStorage() {
    this.sessionStorageService.setUserIdAndBusinessId(this.userId, this.businessId, this.logon, this.distributor);
    this.dtmService.userLoaded({
      userId: this.logon ? this.logon : this.userId,
      businessId: this.businessId,
      logon: this.logon,
      clientId: SYDLEClientID,
    });

    if (this.userId && this.businessId) {
      this.sessionStorageService.setIsLogged(true);
    }
  }

  clearAddress(clearFullAddress = false) {
    const addressFields = ['street', 'quarter', 'city', 'state', 'complement'];

    this.customer.street = '';
    this.customer.quarter = '';
    this.customer.state = '';
    this.customer.city = '';
    this.customer.complement = '';
    if (clearFullAddress) {
      this.customer.number = '';
      this.customer.zipcode = '';
      addressFields.push("number", "zipcode");
    }

    addressFields.forEach((field) => {
      if (this.formControlService.identificationForm.controls[field].disabled) {
        this.enableAndShowField(field);
      }
    });
  }

  private handleRequestError(request: string, err: any, errorMessage?: any) {
    this.submitting = false;
    let errJson = err.error;
    try {
      if (typeof errJson === 'string') {
        errJson = JSON.parse(errJson);
      }
    } catch (e) { }

    let errMessageAnalytics = this.onSubmitIdentificationErrors && this.onSubmitIdentificationErrors.length ? JSON.stringify(this.onSubmitIdentificationErrors) : errorMessage;
    let generalMessages = errJson.generalMessages && errJson.generalMessages.length ? errJson.generalMessages.map(errorMessage => errorMessage.text) : err;

    // MLH004325 - Melhoria de mensagens de errorDetail
    let errorDetail = "";
    if (err && err.status && err.url) {
      errorDetail = "CODE:" + err.status + ":HTTP:" + err.status + ":POST/" + err.url;
    }

    this.dtmService.customErrorLoaded(['error'], {
      errorDetail: errorDetail || JSON.stringify(generalMessages),
      errorMessage: JSON.stringify(errMessageAnalytics),
    });

    this.closeDialogSpinner();
  }

  bindProvisioningParameters() {
    if (this.businessId && this.userId && this.sessionStorageService.getIsLogged()) {
      this.openDialogSpinner();

      this.customer.provisioningParameter.businessId = this.businessId;
      this.customer.provisioningParameter.userId = this.userId;
      this.customer.provisioningParameter.platformAccess = this.platformAccess;

      const classification = this.sessionStorageService.getClassification();
      const validatedMitigation = this.sessionStorageService.getValidatedMitigation();
      const timeStamp = new Date().toISOString();
      this.customerService
        .getAccountData(this.businessId, this.userId, classification, validatedMitigation, timeStamp)
        .subscribe(
          (result) => {
            if (result.businessData) {
              const businessData = result.businessData;

              if (businessData.legalName) {
                this.customer.companyLegalName = businessData.legalName;
                this.hasDigitalCommerceLegalName = true;
                this.disableAndHideField('legalName');
              } else {
                this.hasDigitalCommerceLegalName = false;
                this.enableAndShowField('legalName');
              }

              if (businessData.companyName) {
                this.customer.companyName = businessData.companyName;
              }

              if (businessData.cnpj) {
                this.customer.cnpj = this.formatParameterForField(businessData.cnpj, 'cnpj');
                this.disableAndHideField('cnpj');

                if (businessData.mitigated !== undefined) {
                  this.mitigated = businessData.mitigated;
                } else {
                  this.hasBusinessDataErrors = true;
                }
              } else {
                this.hasBusinessDataErrors = true;
              }

              if (this.mitigated) {
                this.showCustomError('mitigationMessageError');
              }

              if (this.hasBusinessDataErrors) {
                this.showCustomError('requiredBusinessDataNotFound');
              }
              if (businessData.address && businessData.address.zipcode) {
                this.customer.zipcode = this.lpad(businessData.address.zipcode, 8, 0);
                this.fillAddressParameters(businessData.address);
                this.enableAndShowField('zipcode');

                if (businessData.address.number) {
                  this.customer.number = businessData.address.number;
                  this.hasDigitalCommerceAddressData = true;
                } else {
                  this.hasDigitalCommerceAddressData = false;
                  this.closeDialogSpinner();
                  this.firstSubmit = false;
                }
              } else {
                this.clearAddress();
                this.hasDigitalCommerceAddressData = false;
                this.closeDialogSpinner();
                this.firstSubmit = false;
              }
            }

            if (result.userData) {
              const userData = result.userData;

              if (userData.cpf) {
                this.customer.cpf = this.formatParameterForField(userData.cpf, 'cpf');
                this.disableAndHideField('cpf');
              } else {
                this.hasUserDataErrors = true;
              }

              if (userData.phoneNumber) {
                this.customer.cellphone = userData.phoneNumber;
                this.customer.provisioningParameter.cellphone = this.customer.cellphone;
                this.disableAndHideField('cellphone');
              } else {
                this.hasUserDataErrors = true;
              }

              if (userData.name) {
                this.customer.name = userData.name;
                this.disableAndHideField('name');
              } else {
                this.hasUserDataErrors = true;
              }

              if (userData.birthDate) {
                this.customer.birthDate = this.formatParameterForField(userData.birthDate, 'birthDate');
                this.disableAndHideField('birthDate');
              } else {
                this.hasUserDataErrors = true;
              }

              if (userData.email) {
                this.customer.email = userData.email;
                this.customer.provisioningParameter.email = this.customer.email;
                this.disableAndHideField('email');
              } else {
                this.hasUserDataErrors = true;
              }

              if (this.hasUserDataErrors) {
                this.showCustomError('requiredUserDataNotFound');
              }
            }

            this.sessionStorageService.setValidationDataFromCustomer(this.customer);
            if (this.firstSubmit) {
              this.checkAndSubmit();
              this.firstSubmit = false;
            }
          },
          (error) => {
            this.showCustomError('provisioningDataIntegrationError', error);

            //Remover estrutura após identificar o problema
            this.utils.createAdobeAnalyticsLog('getAccountData', JSON.stringify(error), JSON.stringify({
              'businessId': this.businessId,
              'userId': this.userId,
              'productClassification': classification,
              'validatedMitigation': validatedMitigation,
              'timeStamp': timeStamp
            })).subscribe();
          }
        );
    } else if (!this.sessionStorageService.getIsLogged()) {
      // Faz nada
    } else if (this.sessionStorageService.getIsLogged()) {
      this.showCustomError('missingUserAndBusinessId');
    }
  }

  formatParameterForField(value, type): string {
    let formatted = '';
    let regex: RegExp;
    let format: string;

    if (!value) {
      return;
    }

    if (type === 'cpf') {
      regex = new RegExp(/^(\d{3})(\d{3})(\d{3})(\d{2})/g);
      format = '$1.$2.$3-$4'; // 123.456.789-01
    } else if (type === 'cnpj') {
      regex = new RegExp(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g);
      format = '$1.$2.$3/$4-$5'; // 83.594.046/0001-03
    } else if (type === 'birthDate') {
      regex = new RegExp(/^(\d{2})(\d{2})(\d{4})/g);
      format = '$1/$2/$3'; // 27/02/2018
    } else if (type === 'addressNumber') {
      regex = new RegExp(/(\D)/g);
      format = ''; // 2111
    }

    formatted = value.replace(regex, format);
    return formatted;
  }

  lpad(n, width, z): string {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  }

  getFormattedBirthDate(date: string): string {
    const newDate = date.split('-');
    return `${newDate[2]}/${newDate[1]}/${newDate[0]}`;
  }

  getProvisioningParametersFromSessionStorage() {
    this.userId = this.sessionStorageService.getUserId();
    this.businessId = this.sessionStorageService.getBusinessId();

    // Se não tiver user e business na session storage e veio da vitrine híbrida
    let hybridPackageRedirect = Boolean(this.cookieService.get('hybridPackageRedirect'));
    if (!this.userId && !this.businessId && hybridPackageRedirect) {
      this.userId = this.cookieService.get('userId');
      this.businessId = this.cookieService.get('businessId');
    }

    this.dtmService.userLoaded({
      userId: this.userId,
      businessId: this.businessId,
      clientId: SYDLEClientID,
    });

    if (!this.userId || !this.businessId) {
      this.sessionStorageService.setIsLogged(false);
    } else {
      this.sessionStorageService.setIsLogged(true);
    }
  }

  // Handling Errors
  showCustomError(customErrorKey: string, integrationError?: any) {
    let integrationErrorMessage: any;
    switch (customErrorKey) {
      case 'mitigationMessageError':
        // Erro de Mitigação (Quando usuário não pode concluir a compra)
        this.onSubmitIdentificationErrors.push(errorMapping[customErrorKey]);
        // Analytics

        this.dtmService.customErrorLoaded(['error'], {
          errorDetail: 'Usuário Mitigado',
          errorMessage: errorMapping[customErrorKey],
        });
        break;
      case 'mitigationMessageErrorPreCadastro':
        // Venda Deslogada - mitigaçao no pre-cadastro do cliente
        // Erro de Mitigação (Quando usuário não pode concluir a compra)
        this.onSubmitIdentificationErrors.push(errorMapping['mitigationMessageError']);
        // Analytics
        this.dtmService.customErrorLoaded(['error'], {
          errorDetail: integrationError,
          errorMessage: 'Usuário Mitigado - Pre Cadastro',
        });
        break;
      case 'mitigationMessageErrorPosCadastro':
        // Venda Deslogada - mitigaçao no pos-cadastro do cliente
        // Erro de Mitigação (Quando usuário não pode concluir a compra)
        this.onSubmitIdentificationErrors.push(errorMapping['mitigationMessageError']);
        // Analytics
        this.dtmService.customErrorLoaded(['error'], {
          errorDetail: integrationError,
          errorMessage: 'Usuário Mitigado - Pos Cadastro',
        });
        break;
      case 'requiredUserDataNotFound':
        // Erro de Dados ausentes (Quando dado obrigatório que não pode ser alterado não é fornecido por DC)
        this.onSubmitIdentificationErrors.push(errorMapping[customErrorKey]);
        // Analytics
        this.dtmService.customErrorLoaded(['error'], {
          errorDetail: `Integração com DigitalCommerce não retornou um dado Obrigatório para o user ${this.userId}`,
          errorMessage: errorMapping[customErrorKey],
        });
        break;
      case 'requiredBusinessDataNotFound':
        // Erro de Dados ausentes (Quando dado obrigatório que não pode ser alterado não é fornecido por DC)
        this.onSubmitIdentificationErrors.push(errorMapping[customErrorKey]);
        // Analytics
        this.dtmService.customErrorLoaded(['error'], {
          errorDetail: `Integração com DigitalCommerce não retornou um dado Obrigatório para o business ${this.businessId}`,
          errorMessage: errorMapping[customErrorKey],
        });
        break;
      case 'requiredIntegrationDataNotFound':
        // Erro de Dados ausentes (Quando dado obrigatório que não pode ser alterado não é fornecido por DC)
        this.onSubmitIdentificationErrors.push(errorMapping[customErrorKey]);
        // Analytics
        this.dtmService.customErrorLoaded(['error'], {
          errorDetail: `Integração com DigitalCommerce não retornou um dado obrigatório`,
          errorMessage: errorMapping[customErrorKey],
        });
        break;
      case 'missingUserAndBusinessId':
        // Erro de Dados ausentes (Quando dado obrigatório que não pode ser alterado não é fornecido por DC)
        this.onSubmitIdentificationErrors.push(errorMapping[customErrorKey]);
        // Analytics
        this.dtmService.customErrorLoaded(['error'], {
          errorDetail: `BusinessID e UserID não informados pela URL/SessionStorage`,
          errorMessage: errorMapping[customErrorKey],
        });
        break;
      case 'provisioningDataIntegrationError':
        // Erro de Integração com ONE/DC
        this.onSubmitIdentificationErrors.push(errorMapping[customErrorKey]);
        integrationErrorMessage = this.handleIntegrationError(integrationError);
        console.error(integrationErrorMessage);

        // Analytics
        this.dtmService.customErrorLoaded(['error'], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: errorMapping[customErrorKey],
        });
        break;
      case 'updateAddressFromZipcodeIntegration':
        // Erro de Integração com ONE para obter endereço
        integrationErrorMessage = this.handleIntegrationError(integrationError);
        console.error(integrationErrorMessage);

        // Analytics
        this.dtmService.customErrorLoaded(['error'], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: errorMapping[customErrorKey],
        });
        break;
      case 'checkIfAlreadyPurchasedError':
        // Erro de Integração com ONE para obter endereço
        this.onSubmitIdentificationErrors.push(errorMapping[customErrorKey]);
        integrationErrorMessage = this.handleIntegrationError(integrationError);
        console.error(integrationErrorMessage);

        // Analytics
        this.dtmService.customErrorLoaded(['error'], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: errorMapping[customErrorKey],
        });
        break;
      case 'getAddressByZipcode':
        integrationErrorMessage = this.handleIntegrationError(integrationError);
        console.error(integrationErrorMessage);
        // Analytics
        this.dtmService.customErrorLoaded(['error'], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: 'Informe um CEP válido',
        });
        break;
      case 'cartIntegrationError':
        integrationErrorMessage = this.handleIntegrationError(integrationError);
        console.error(integrationErrorMessage);

        // Analytics
        this.dtmService.customErrorLoaded(['error'], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: integrationErrorMessage.userMessage,
        });
        break;
      case 'userNotAssociateError':
        // CPF não pertence ao quadro societário da empresa
        this.onSubmitIdentificationErrors.push(errorMapping[customErrorKey]);
        // Analytics
        this.dtmService.customErrorLoaded(['error'], {
          errorDetail: integrationError,
          errorMessage: errorMapping[customErrorKey],
        });

        break;
      case 'invalidChecksum':
        // Checksum calculado diferente do que veio da URL
        this.onSubmitIdentificationErrors.push(errorMapping[customErrorKey]);
        // Analytics
        this.dtmService.customErrorLoaded(['error'], {
          errorDetail: JSON.stringify(errorMapping[customErrorKey]),
          errorMessage: errorMapping[customErrorKey],
        });

        break;
      case 'invalidTokenTelevendas':
        // validationToken incorreto para o televendas
        this.onSubmitIdentificationErrors.push(errorMapping[customErrorKey]);
        // Analytics
        this.dtmService.customErrorLoaded(['error'], {
          errorDetail: JSON.stringify(errorMapping[customErrorKey]),
          errorMessage: errorMapping[customErrorKey],
        });
        break;
      default:
        // Erro genérico
        this.onSubmitIdentificationErrors.push(errorMapping.unexpectedError);

        // Analytics
        this.dtmService.customErrorLoaded(['error'], {
          errorDetail: errorMapping[errorMapping.unexpectedError],
          errorMessage: errorMapping.unexpectedError,
        });
        break;
    }

    // Parando de fazer o submit e ocultando o dialogSpinner.
    // block all fields
    this.disableAndHideField('all');
    this.showBackButton = true;
    if (customErrorKey === 'userNotAssociateError') {
      this.showBackButton = false;
    }
    this.submitting = false;
    this.closeDialogSpinner();
  }

  // Field and Form Controls
  disableAndHideField(fieldName: string) {
    if (fieldName === 'all') {
      Object.keys(this.formControlService.identificationForm.controls).forEach(
        (key) => {
          const keyName = key.toString();
          this.formControlService.identificationForm.controls[keyName].disable();
          this.hideFields[fieldName] = true;
        }
      );
    } else {
      if (this.formControlService.identificationForm.controls[fieldName]) {
        this.formControlService.identificationForm.controls[fieldName].disable();
        this.hideFields[fieldName] = true;
      }
    }
  }

  setFieldAsReadOnly(fieldName: string) {
    if (this.formControlService.identificationForm.controls[fieldName]) {
      this.formControlService.identificationForm.controls[fieldName].disable();
    }
  }

  enableAndShowField(fieldName: string) {
    if (['legalName', 'zipcode'].indexOf(fieldName) >= 0) {
      this.hideRegister = false;
      this.storeIdentificationIndex(0);
    }
    if (this.formControlService.identificationForm.controls[fieldName]) {
      this.formControlService.identificationForm.controls[fieldName].enable();
      this.hideFields[fieldName] = false;
    }
  }

  handleIntegrationError(error: any): any {
    const resultError: any = {};

    try {
      if (typeof error === 'string') {
        error = JSON.parse(error);
      }
      if (error.status && error.error) {
        resultError.status = error.status;
        resultError.endpoint = error.url && error.url.substring(error.url.indexOf("/api/1") + 6);
        resultError.name = error.name;

        resultError.handledError = !!error.error._messages.filter((message) => {
          return message.code !== null;
        });

        resultError.errors = error.error._messages.filter((message) => {
          return message.type === 'ERROR';
        });

        resultError.warnings = error.error._messages.filter((message) => {
          return message.type === 'WARNING';
        });

        let parseObj;
        try {
          parseObj = JSON.parse(resultError.errors[0].text);
        } catch (err) { }

        if (parseObj && parseObj.context !== undefined) {
          resultError.context = parseObj.context;
          resultError.userMessage = parseObj.message;
          resultError.errorCode = resultError.errors[0].code || parseObj.code;
          resultError.errors[0].text = resultError.userMessage;
        }

        // Nova errorString
        resultError.errorString = (resultError.context || "SYDLE") + ":CODE:" + error.status + ":HTTP:" + (resultError.errorCode || resultError.status) + ":POST/" + resultError.endpoint + ":" + JSON.stringify(resultError.errors.map(({ text }) => text));

        // resultError.errorString = `${resultError.status}:${resultError.name}:${resultError.endpoint}:${JSON.stringify(resultError.errors)}:${JSON.stringify(resultError.warnings)}`;
      } else {
        resultError.errorString = JSON.stringify(error);
      }
    } catch (e) {
      resultError.errorString = JSON.stringify(error);
    }
    return resultError;
  }

  /** Abre dialog em caso de erro durante a venda deslogada */
  openErrorDialog(dialogData, errorDetail?: string, errorMessage?: string) {
    const data = DialogData.fromPreset(dialogData);

    this.dialog.open(DialogAlertComponent, {
      disableClose: true,
      panelClass: 'pme-dialog-alert-panel',
      autoFocus: false,
      data: data
    });

    // Analytics
    this.dtmService.customErrorLoaded(['error'], {
      errorDetail: errorDetail,
      errorMessage: errorMessage ? errorMessage : dialogData.title,
    });
  }

  deleteCouponFromCart() {
    // Apaga o cupom do carrinho atual
    const currentCart = this.cartService.getCurrentCart();
    if (currentCart) {
      currentCart.couponIdentifier = null;
      currentCart.appliedDiscounts = [];
      currentCart.hasValidAppliedCoupon = false;
      this.cartService.setCart(currentCart);
    }
    sessionStorage.removeItem('coupon');
  }

  onAutomaticRechargeChange(event) {
    this.customer.provisioningParameter.allowAutomaticRecharge = event;
  }

  fillCartWithUrlParameters() {
    const cart = this.cartService.getCurrentCart();
    let discounts = null;
    let additionalData = this.sessionStorageService.getAdditionalData();

    const sessionCoupon = sessionStorage.getItem('coupon');
    if (cart && cart.couponIdentifier && !this.couponUrl) {
      // Obtem o cupom que ja esta aplicado no carrinho
      this.couponUrl = cart.couponIdentifier;
      discounts = [this.couponUrl];
    } else if (sessionCoupon && !this.couponUrl) {
      // Obtem cupom da sessionStorage, se existir, e se nao houver cupom na URL
      this.couponUrl = sessionCoupon;
      discounts = [this.couponUrl];
    } else if (!cart && this.couponUrl) {
      // Carrinho inicializando, e com cupom vindo da URL
      discounts = [this.couponUrl];
    }

    // Parametros adicionais usados na venda do Lista Online
    if (this.externalSignatureId) {
      additionalData['externalSignatureId'] = this.externalSignatureId;
    }
    if (this.checksum) {
      additionalData['checksum'] = this.checksum;
    }
    if (this.ref) {
      additionalData['ref'] = this.ref;
    }
    if (this.quantidade) {
      additionalData['quantidade'] = this.quantidade;
    }
    if (this.internalReference) {
      additionalData['internalReference'] = this.internalReference;
    }
    if (this.validationToken) {
      additionalData['validationToken'] = this.validationToken;
    }

    this.sessionStorageService.setAdditionalData(additionalData);

    if (this.customer) {
      this.sessionStorageService.setValidationData({ "byParameter": { "businessId": this.businessId, "userId": this.userId } });
    }

    const cartId = cart && cart._id ? cart._id : null;
    const cartType = cart && cart.type ? cart.type : 'SALE';
    const productIdentifier = this.sessionStorageService.getProduct();
    this.cartService.simulate(cartId, cartType, productIdentifier, 'IDENTIFICATION', discounts, this.userId, this.businessId, null, additionalData).subscribe(simulatedCarts => {

      // Validar checksum
      if (simulatedCarts[0] && simulatedCarts[0].invalidCS === true) {
        this.invalidChecksum = true;
        this.showCustomError('invalidChecksum');
      }

      this.cartService.setCarts(simulatedCarts);
      this.cartService.setCartByPaymentMethod(this.cartService.carts[0].paymentMethod.identifier);
      // const creditCardCart = this.cartService.carts.find(cart => cart.paymentMethod.identifier === 'CREDIT_CARD');
      // if (creditCardCart) {
      //   this.cartService.setCartByPaymentMethod('CREDIT_CARD');
      // } else {
      //   this.cartService.setCartByPaymentMethod('BANK_BILLET');
      // }

      if (this.cartComponent) {
        this.cartComponent.update();

        if (this.classificationIdentifier && this.classificationIdentifier === 'consulta-e-recuperacao-de-dividas') {
          if (this.cartService.carts && this.cartService.carts.length === 1) {
            if (this.cartService.carts[0].paymentMethod.identifier !== 'CREDIT_CARD') {
              this.customer.provisioningParameter.allowAutomaticRecharge = false;
            } else if (!this.validationToken) {
              if (this.businessId !== "600b2b05bb708c15e7f39d67") {
                this.cartComponent.activateAutomaticRecharge(true);
              }
            }
          } else {
            if (this.businessId !== "600b2b05bb708c15e7f39d67") {
              this.cartComponent.activateAutomaticRecharge(true);
            }
          }
        }
      }

    }, (err) => {
      this.showCustomError('cartIntegrationError', err);
      this.cartLoaded = true;
    });
  }

  getTelevendasData() {
    if (this.validationToken) {
      this.customerService.getTelevendasData(this.validationToken)
        .subscribe(
          (result) => {
            if (result) {
              sessionStorage.setItem('isTelevendas', 'true');

              if (result.salesPerson) {
                sessionStorage.setItem('salesPerson', result.salesPerson);
              }

              if (result.address) {
                this.customer.zipcode = this.lpad(result.address.zipcode, 8, 0);
                this.customer.city = result.address.city;
                this.customer.complement = result.address.complement;
                this.customer.street = result.address.street;
                this.customer.state = result.address.state;
                this.customer.quarter = result.address.quarter;
                this.customer.number = result.address.number;
              }

              if (result.companyLegalName) {
                this.customer.companyLegalName = result.companyLegalName;
              }

              if (result.disableRecharge) {
                this.sessionStorageService.setAdditionalData({
                  byParameter: {
                    disableRecharge: true
                  }
                })
              }

              let pageNameTelevendas = Dtm.Identificacao.replace("SYDLE", "SYDLE:TELEVENDAS");
              this.dtmService.pageLoaded(Dtm.Identificacao, true, getDtm(pageNameTelevendas, this.classificationIdentifier));
              let classificationNameMapTelevendas = {
                "Consulta e Cobrança de Dívidas": "PacotedeCreditoMPME-Televendas",
                "Saúde do seu Negócio": "SaudeFinanceira-Televendas",
                "Serasa Monitora": "Serasa-Monitora-Televendas"
              };

              let classificationNameTrigger;
              if (this.classificationName) {
                if (classificationNameMapTelevendas[this.classificationName]) {
                  classificationNameTrigger = classificationNameMapTelevendas[this.classificationName];
                }
                classificationNameTrigger = this.classificationName;
              } else {
                if (this.classificationIdentifier) {
                  if (Mapping[this.classificationIdentifier]) {
                    classificationNameTrigger = Mapping[this.classificationIdentifier];
                  } else {
                    classificationNameTrigger = this.classificationIdentifier;
                  }
                } else {
                  classificationNameTrigger = null;
                }
              }

              this.dtmService.productsLoaded([
                {
                  identifier: this.product,
                  classificationName: classificationNameTrigger
                }
              ]);
              // this.dtmService.sendPageLoadEvent();
            }
          }, (error) => {
            this.showCustomError('invalidTokenTelevendas', error);
          }
        );

    }
  }

  openCadastroDeslogado() {
    // this.dtmService.customClickEvent(
    //   'Cadastre-se agora!'
    // );
    window.location.href = "https://www.serasaempreendedor.com.br/cadastro-deslogado";

  }
}
